import { FieldValueEntity } from 'shared/domain/fieldValue/entity';
import {
  makeDefaultAddBatch,
  makeDefaultCount,
  makeDefaultGetMany,
  makeDefaultGetOne,
  makeDefaultRemoveBatch,
} from '../defaultDaoFactories';
import { entityDbClearFactory } from '../entityDbClearFactory';
import db, { HustroDbTablesUnion } from '../index';

export interface FieldValueDbConfig {
  tableName: string;
  serviceTableName: string;
  serviceClearFunction: () => Promise<void>;
  broadcastClearFunction: () => void;
}

export interface FieldValueDbModule {
  clear: () => Promise<void>;
  quantity: () => Promise<number>;
  get: () => Promise<FieldValueEntity[]>;
  getOne: (id: string) => Promise<FieldValueEntity | undefined>;
  addBatch: (entities: FieldValueEntity[]) => Promise<void>;
  updateBatch: (entities: FieldValueEntity[]) => Promise<void>;
  removeBatch: (ids: string[]) => Promise<void>;
}
export function makeFieldValueDbModule(
  config: FieldValueDbConfig
): FieldValueDbModule {
  const {
    tableName,
    serviceTableName,
    serviceClearFunction,
    broadcastClearFunction,
  } = config;

  const table = (db as any)[tableName];

  const clear = entityDbClearFactory(
    db,
    [
      tableName as HustroDbTablesUnion,
      serviceTableName as HustroDbTablesUnion,
    ],
    () => table.clear(),
    serviceClearFunction,
    broadcastClearFunction
  );

  const quantity = makeDefaultCount<FieldValueEntity>(db, table);

  const get = makeDefaultGetMany<FieldValueEntity>(db, table);

  const getOne = makeDefaultGetOne<string, FieldValueEntity>(
    db,
    table,
    '_id'
  );

  const addBatch = async (entities: FieldValueEntity[]): Promise<void> => {
    await makeDefaultAddBatch<FieldValueEntity>(db, table)(entities);
  };

  const updateBatch = addBatch;

  const removeBatch = async (ids: string[]): Promise<void> => {
    await makeDefaultRemoveBatch<string, FieldValueEntity>(
      db,
      table,
      '_id'
    )(ids);
  };

  return {
    clear,
    quantity,
    get,
    getOne,
    addBatch,
    updateBatch,
    removeBatch,
  };
}
